import React, { Component } from 'react'
import '../OnlineHelpPage.css'
import LivingClassOrdinaryImg from './img/LivingClass_ordinary_001.png'

export default class LivingClassOrdinary extends Component {
  render() {
    return (
      <div className="main-window">
        <div className="main-window-title">普通用户使用在线课堂</div>
        <div className="main-window-content">普通用户，进入在线课堂界面，点击教程，即可查看具体教程，并可添加学习</div>
        <img src={LivingClassOrdinaryImg} className="main-window-img"></img>
      </div>
    )
  }
}
